import React, { useState, useEffect } from "react"
import "../../Styles/Reservation.css"
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  Timestamp,
} from "firebase/firestore"
import { db, auth } from "../../Firebase/config"
import Modal from "react-modal"
import Notify from "../Componentslogic/Usenotifications"
import ReactSelect from "react-select"
import bcrypt from "bcryptjs"
import { signOut } from "firebase/auth" // Ensure signOut is imported from Firebase Auth
import axios from "axios"

Modal.setAppElement("#root")

const AdminStaff = () => {
  const [staff, setStaff] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [newEmployee, setNewEmployee] = useState({
    name: "",
    role: "",
    username: "",
    password: "",
    contactNumber: "",
    Delivered: "",
    loggedIn: false,
  })
  const [currentEmployee, setCurrentEmployee] = useState(null)
  const [selectedRole, setSelectedRole] = useState(null)
  const [sortOption, setSortOption] = useState(null)
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)
  const [adminPassword, setAdminPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")

  // Fetch employees from Firestore
  useEffect(() => {
    const fetchStaff = async () => {
      const querySnapshot = await getDocs(collection(db, "Staff"))
      setStaff(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
    }
    fetchStaff()
  }, [])

  const handlePasswordModalOpen = () => {
    setIsPasswordModalOpen(true)
  }

  const handlePasswordModalClose = () => {
    setIsPasswordModalOpen(false)
    setAdminPassword("")
    setNewPassword("")
    setConfirmNewPassword("")
  }

  const handlePasswordChange = async (e) => {
    e.preventDefault()

    try {
      // Fetch all users with the role 'Manager'
      const querySnapshot = await getDocs(collection(db, "Staff"))
      const managers = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => user.role === "Manager")

      let isValidAdminPassword = false

      // Check the entered password against all manager passwords
      for (const manager of managers) {
        if (await bcrypt.compare(adminPassword, manager.password)) {
          isValidAdminPassword = true
          break
        }
      }

      if (!isValidAdminPassword) {
        Notify("Invalid admin password.", "error")
        return
      }

      // Hash the new password
      const salt = await bcrypt.genSalt(10)
      const hashedPassword = await bcrypt.hash(newPassword, salt)

      // Update the user's password in Firestore
      const employeeDocRef = doc(db, "Staff", currentEmployee.id)
      await updateDoc(employeeDocRef, { password: hashedPassword })

      Notify("Password updated successfully!", "success")

      // Reset fields
      setAdminPassword("")
      setNewPassword("")
      setConfirmNewPassword("")
      handleEditModalClose()
    } catch (error) {
      console.error("Error updating password:", error)
      Notify("Failed to update password.", "error")
    }
  }
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption)
  }

  const handleSortChange = (selectedOption) => {
    setSortOption(selectedOption)
  }

  const handleAddModalOpen = () => {
    setIsAddModalOpen(true)
  }

  const handleAddModalClose = () => {
    setIsAddModalOpen(false)
  }

  const handleEditModalOpen = (employee) => {
    // Ensure currentEmployee is fully populated
    setCurrentEmployee({ ...employee })
    setIsEditModalOpen(true)
  }

  const handleEditModalClose = () => {
    setIsEditModalOpen(false)
    setCurrentEmployee(null)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewEmployee((prev) => ({ ...prev, [name]: value }))
  }

  const handleEditInputChange = (e) => {
    const { name, value } = e.target
    setCurrentEmployee((prev) => ({ ...prev, [name]: value }))
  }

  const handleAddEmployee = async (e) => {
    e.preventDefault()
    try {
      // ✅ Call Backend API to Create Employee
      const response = await axios.post("/api/add-staff", {
        name: newEmployee.name,
        username: newEmployee.username,
        password: newEmployee.password,
        role: newEmployee.role,
        contactNumber: newEmployee.contactNumber,
      })

      const { userId } = response.data

      if (!userId) {
        throw new Error("Failed to create staff user.")
      }

      // ✅ Update Local UI (Show new employee in the list)
      setStaff((prevStaff) => [
        ...prevStaff,
        {
          id: userId,
          ...newEmployee,
          loggedIn: false, // Mark as not logged in
        },
      ])

      Notify("Employee added successfully!", "success")
      setIsAddModalOpen(false)
      setNewEmployee({
        name: "",
        username: "",
        password: "",
        role: "",
        contactNumber: "",
      })
    } catch (error) {
      console.error("Error adding employee:", error)
      Notify("Failed to add employee.", "error")
    }
  }
  const handleEditEmployee = async (e) => {
    e.preventDefault()
    if (!currentEmployee || !currentEmployee.id) {
      console.log(currentEmployee)
      Notify("Invalid employee data.", "error")
      return
    }
    try {
      const employeeDocRef = doc(db, "Staff", currentEmployee.id)
      await updateDoc(employeeDocRef, {
        name: currentEmployee.name,
        role: currentEmployee.role,
        contactNumber: currentEmployee.contactNumber,
        salary: parseFloat(currentEmployee.salary),
      })

      // Update the employee in the local state
      setStaff((prevStaff) =>
        prevStaff.map((employee) =>
          employee.id === currentEmployee.id ? currentEmployee : employee
        )
      )

      Notify("Employee updated successfully!", "success")
      setIsEditModalOpen(false)
      setCurrentEmployee(null)
    } catch (error) {
      console.error("Error updating employee:", error)
      Notify("Failed to update employee.", "error")
    }
  }

  const toggleLoginState = async (employee) => {
    try {
      const employeeDocRef = doc(db, "Staff", employee.id)
      await updateDoc(employeeDocRef, {
        loggedIn: false,
        loggedOutbyAdminAt: Timestamp.now(), // Add the timestamp for logout
      })

      Notify("Successfully logged out", "success")
      setStaff((prevStaff) =>
        prevStaff.map((item) =>
          item.id === employee.id
            ? {
                ...item,
                loggedIn: false,
                loggedOutbyAdminAt: new Date(),
              }
            : item
        )
      )
    } catch (error) {
      console.error("Error toggling login state:", error)
      Notify("Failed to update login status", "error")
    }
  }
  const roleOptions = [
    { value: "all", label: "All" },
    { value: "Manager", label: "Manager" },
    { value: "Staff", label: "Staff" },
    { value: "Driver", label: "Driver" },
  ]

  const applyFilters = () => {
    let filteredStaff = [...staff]

    if (selectedRole && selectedRole.value !== "all") {
      filteredStaff = filteredStaff.filter(
        (employee) => employee.role === selectedRole.value
      )
    }

    return filteredStaff
  }

  return (
    <div className="dashboard-container">
      <main className="main-content">
        <header className="header">
          <input
            type="text"
            placeholder="Search by employee name..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="search-box"
          />
          <ReactSelect
            options={roleOptions}
            onChange={handleRoleChange}
            placeholder="Filter by Role"
            styles={{
              control: (provided) => ({
                ...provided,
                width: "150px", // Set the width
              }),
              menu: (provided) => ({
                ...provided,
                width: "150px", // Ensure dropdown matches width
              }),
            }}
          />

          <button onClick={handleAddModalOpen} className="btns-Admin">
            Add Employee
          </button>
        </header>

        <section className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Contact Number</th>
                <th>Role</th>

                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {applyFilters()
                .filter((employee) =>
                  employee.name
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
                )
                .map((employee) => (
                  <tr key={employee.id}>
                    <td>{employee.name}</td>
                    <td>{employee.contactNumber}</td>
                    <td>{employee.role} </td>

                    <td>
                      <button
                        onClick={() => handleEditModalOpen(employee)}
                        className="btns-Admin"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </section>

        {/* Add Employee Modal */}
        <Modal
          isOpen={isAddModalOpen}
          onRequestClose={handleAddModalClose}
          contentLabel="Add Employee"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            content: {
              position: "static",
              inset: "unset",
              width: "400px",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              backgroundColor: "#fff",
            },
          }}
        >
          <h4 className="modal-title">Add Employee</h4>
          <form onSubmit={handleAddEmployee} className="modal-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                value={newEmployee.name}
                onChange={handleInputChange}
                placeholder="Name"
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="role">Role</label>
              <ReactSelect
                options={roleOptions}
                onChange={(selectedOption) =>
                  setNewEmployee((prev) => ({
                    ...prev,
                    role: selectedOption.value,
                  }))
                }
                placeholder="Select Role"
                className="select-role"
              />
            </div>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                name="username"
                value={newEmployee.username}
                onChange={handleInputChange}
                placeholder="Username"
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                value={newEmployee.password}
                onChange={handleInputChange}
                placeholder="Password"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="contactNumber">Contact Number</label>
              <input
                id="contactNumber"
                type="text"
                name="contactNumber"
                value={newEmployee.contactNumber}
                onChange={handleInputChange}
                placeholder="Contact Number"
                required
                className="form-input"
              />
            </div>

            <div className="modal-actions">
              <button type="submit" className="btn-submit">
                Add
              </button>
              <button
                type="button"
                onClick={handleAddModalClose}
                className="btn-cancel"
              >
                Cancel
              </button>
            </div>
          </form>
        </Modal>
        {/* Edit Employee Modal */}

        <>
          {currentEmployee && (
            <>
              <Modal
                isOpen={isEditModalOpen}
                onRequestClose={handleEditModalClose}
                contentLabel="Edit Employee"
                style={{
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  content: {
                    position: "static",
                    inset: "unset",
                    width: "400px",
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#fff",
                  },
                }}
              >
                <h4 className="modal-title">Edit Employee</h4>
                <form onSubmit={handleEditEmployee} className="modal-form">
                  <div className="form-group">
                    <label htmlFor="edit-name">Name</label>
                    <input
                      id="edit-name"
                      type="text"
                      name="name"
                      value={currentEmployee.name}
                      onChange={handleEditInputChange}
                      placeholder="Name"
                      required
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="edit-contactNumber">Contact Number</label>
                    <input
                      id="edit-contactNumber"
                      type="text"
                      name="contactNumber"
                      value={currentEmployee.contactNumber}
                      onChange={handleEditInputChange}
                      placeholder="Contact Number"
                      required
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <button
                      type="button"
                      onClick={handlePasswordModalOpen}
                      className="btn-submit"
                    >
                      Change Password
                    </button>
                  </div>
                  <div className="modal-actions">
                    <button type="submit" className="btn-submit">
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={handleEditModalClose}
                      className="btn-cancel"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Modal>

              <Modal
                isOpen={isPasswordModalOpen}
                onRequestClose={handlePasswordModalClose}
                contentLabel="Change Password"
                style={{
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  content: {
                    position: "static",
                    inset: "unset",
                    width: "400px",
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#fff",
                  },
                }}
              >
                <h4 className="modal-title">Change Password</h4>
                <form onSubmit={handlePasswordChange} className="modal-form">
                  <div className="form-group">
                    <label htmlFor="admin-password">Admin Password</label>
                    <input
                      id="admin-password"
                      type="password"
                      value={adminPassword}
                      onChange={(e) => setAdminPassword(e.target.value)}
                      placeholder="Enter Admin Password"
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="new-password">New Password</label>
                    <input
                      id="new-password"
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="New Password"
                      required
                      className="form-input"
                    />
                  </div>

                  <div className="modal-actions">
                    <button type="submit" className="btn-submit">
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={handlePasswordModalClose}
                      className="btn-cancel"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Modal>
            </>
          )}
        </>
      </main>
    </div>
  )
}

export default AdminStaff
